import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import "./Services.css";
import "./AboutPage.css";

import Banner from "../Img/About/About Banner.jpg";

function About() {
  return (
    <>
      {/* ============ TOP BANNER IMAGE ============ */}
      <Image
        className="fade-in responsive-img"
        src={Banner}
        height={500}
        width="100%"
        fluid
      />

      <div className="about-page">

        {/* ============ HERO TEXT ============ */}
        <section className="about-hero">
          <span className="about-hero__eyebrow">About Us</span>
          <h1 className="about-hero__title">
            Logistics Built On <span>Trust, Speed &amp; Precision</span>
          </h1>
          <p className="about-hero__subtitle">
            A New Delhi–based integrated logistics company delivering complete supply chain
            solutions across India and worldwide — from factory gate to final destination.
          </p>
        </section>

        {/* ============ WHO WE ARE ============ */}
        <section className="about-section">
          <div className="about-section__inner about-split">
            <div>
              <span className="about-section__eyebrow">Who We Are</span>
              <h2 className="about-section__title">
                Your Single Point of Contact for <span>Every Logistics Need</span>
              </h2>
              <p className="about-section__text">
                <strong>MULTI MODAL OVERSEAS PVT LTD (MMOPL)</strong> is a New Delhi–based integrated
                logistics company offering complete logistics solutions across India and worldwide.
                From ocean and air freight to warehousing, custom clearance, contract logistics and
                crane rentals — we handle the entire supply chain so you can focus on your core business.
              </p>
              <p className="about-section__text">
                With an experienced team, a strong network of carriers and agents, and a customer-first
                approach, we deliver reliable, cost-effective and time-bound logistics services for
                clients across Automobiles, E-Commerce, Pharmaceuticals, Food, Fashion &amp; Retail,
                Chemicals and Commercial Transport sectors.
              </p>
            </div>

            <div className="about-split__visual">
              <div className="about-stat-card">
                <p className="about-stat-card__title">MMOPL at a Glance</p>
                <div className="about-stat-grid">
                  <div className="about-stat">
                    <div className="about-stat__value">7+</div>
                    <div className="about-stat__label">Industries Served</div>
                  </div>
                  <div className="about-stat">
                    <div className="about-stat__value">6</div>
                    <div className="about-stat__label">Core Services</div>
                  </div>
                  <div className="about-stat">
                    <div className="about-stat__value">24/7</div>
                    <div className="about-stat__label">Shipment Tracking</div>
                  </div>
                  <div className="about-stat">
                    <div className="about-stat__value">360°</div>
                    <div className="about-stat__label">Support</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ WHY CHOOSE MMOPL ============ */}
        <section className="about-section about-section--gray">
          <div className="about-section__inner">
            <span className="about-section__eyebrow">Why Choose MMOPL</span>
            <h2 className="about-section__title">
              One Partner. <span>Complete Solutions.</span>
            </h2>
            <p className="about-section__text" style={{ maxWidth: "820px" }}>
              When you require multiple logistics services like air freight, ocean freight,
              transportation, Container Freight Station (CFS) solutions, warehouse management,
              consolidation, project set-up and equipment hiring — an Integrated Logistics Solution
              (ILS) can reduce delivery time and cost. As we become your single point of contact,
              you don't need to coordinate with different vendors — this saves your valuable resources.
            </p>

            <div className="benefits-grid">
              {/* Card 1 — Integrated Solution */}
              <div className="benefit-card">
                <div className="benefit-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm6.93 9h-2.95a15.7 15.7 0 0 0-1.16-5.04A8.02 8.02 0 0 1 18.93 11zM12 4.04c.83 1.2 1.7 2.9 2.13 5.96h-4.26C10.3 6.94 11.17 5.24 12 4.04zM5.07 11a8.02 8.02 0 0 1 4.11-5.04A15.7 15.7 0 0 0 8.02 11H5.07zm0 2h2.95a15.7 15.7 0 0 0 1.16 5.04A8.02 8.02 0 0 1 5.07 13zm6.93 6.96c-.83-1.2-1.7-2.9-2.13-5.96h4.26c-.43 3.06-1.3 4.76-2.13 5.96zM14.82 16.04A15.7 15.7 0 0 0 15.98 11h2.95a8.02 8.02 0 0 1-4.11 5.04z"/>
                  </svg>
                </div>
                <h3 className="benefit-card__title">Integrated Solution</h3>
                <p className="benefit-card__text">
                  All your logistics needs under one roof — less coordination, fewer vendors,
                  faster turnaround.
                </p>
              </div>

              {/* Card 2 — Experienced Team */}
              <div className="benefit-card">
                <div className="benefit-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.4 14.6-3.9-3.9 1.4-1.4 2.5 2.5 5.9-5.9 1.4 1.4-7.3 7.3z"/>
                  </svg>
                </div>
                <h3 className="benefit-card__title">Experienced Team</h3>
                <p className="benefit-card__text">
                  Skilled professionals across key sectors who align our operations with your
                  business objectives and vision.
                </p>
              </div>

              {/* Card 3 — Time & Cost Savings */}
              <div className="benefit-card">
                <div className="benefit-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-1h-1.5v-2H12V9h-2.5V7H11V6h2v1h1.5v2H12v5h2.5v2H13v1z"/>
                  </svg>
                </div>
                <h3 className="benefit-card__title">Time &amp; Cost Savings</h3>
                <p className="benefit-card__text">
                  Optimized routes, strong carrier partnerships and streamlined processes reduce
                  both delivery time and cost.
                </p>
              </div>

              {/* Card 4 — Reliable & Safe */}
              <div className="benefit-card">
                <div className="benefit-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2 4 5v6c0 5.5 3.8 10.7 8 12 4.2-1.3 8-6.5 8-12V5l-8-3zm-1.2 15.2-3.9-3.9 1.4-1.4 2.5 2.5 5.9-5.9 1.4 1.4-7.3 7.3z"/>
                  </svg>
                </div>
                <h3 className="benefit-card__title">Reliable &amp; Safe</h3>
                <p className="benefit-card__text">
                  Every consignment handled with international safety standards and complete
                  documentation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ MISSION & VISION ============ */}
        <section className="about-section">
          <div className="about-section__inner">
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <span className="about-section__eyebrow">Our Compass</span>
              <h2 className="about-section__title">
                Mission &amp; <span>Vision</span>
              </h2>
            </div>

            <div className="mv-grid">
              {/* Mission */}
              <div className="mv-card mv-card--mission">
                <div className="mv-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <circle cx="12" cy="12" r="6" />
                    <circle cx="12" cy="12" r="2" />
                  </svg>
                </div>
                <p className="mv-card__label">Our Mission</p>
                <h3 className="mv-card__title">Dependable. Safe. Cost-Effective.</h3>
                <p className="mv-card__text">
                  To provide dependable, safe and cost-effective logistics solutions that consistently
                  exceed client expectations — through modern infrastructure, trained professionals
                  and continuous improvement.
                </p>
              </div>

              {/* Vision */}
              <div className="mv-card mv-card--vision">
                <div className="mv-card__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </div>
                <p className="mv-card__label">Our Vision</p>
                <h3 className="mv-card__title">India's Most Trusted Logistics Partner</h3>
                <p className="mv-card__text">
                  To be recognised as one of India's most trusted integrated logistics partners —
                  delivering excellence across every mode of transport and every stage of the
                  supply chain.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ 3 PILLARS ============ */}
        <section className="about-section about-section--gray">
          <div className="about-section__inner">
            <div style={{ textAlign: "center", marginBottom: "40px" }}>
              <span className="about-section__eyebrow">What You Can Expect</span>
              <h2 className="about-section__title">
                Built on <span>Three Promises</span>
              </h2>
            </div>

            <div className="pillars-grid">
              {/* Fast Service */}
              <div className="pillar">
                <div className="pillar__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                  </svg>
                </div>
                <h3 className="pillar__title">Fast Service</h3>
                <p className="pillar__text">
                  We ensure your cargo reaches the destination as quickly as possible and is
                  delivered on time — every time.
                </p>
              </div>

              {/* 100% Accuracy */}
              <div className="pillar">
                <div className="pillar__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                </div>
                <h3 className="pillar__title">100% Accuracy</h3>
                <p className="pillar__text">
                  That's why customers trust us — years of experience in logistics and transportation
                  means precision in every shipment.
                </p>
              </div>

              {/* Safety & Guarantee */}
              <div className="pillar">
                <div className="pillar__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    <polyline points="9 12 11 14 15 10" />
                  </svg>
                </div>
                <h3 className="pillar__title">Safety &amp; Guarantee</h3>
                <p className="pillar__text">
                  Your cargo is meticulously packed, handled and delivered by our team with
                  full safety and guarantee.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ BOTTOM CTA ============ */}
        <div className="about-cta">
          <h2 className="about-cta__title">Ready to Move Your Cargo with MMOPL?</h2>
          <p className="about-cta__text">
            Talk to our logistics team about your shipment, route or warehousing needs —
            we'll respond promptly with a tailored plan.
          </p>
          <div className="about-cta__buttons">
            <Link to="/Contact" className="about-cta__btn about-cta__btn--primary">
              Contact Us
            </Link>
            <Link to="/Industries" className="about-cta__btn about-cta__btn--secondary">
              Explore Industries
            </Link>
          </div>
        </div>

      </div>
    </>
  );
}

export default About;